import { Component, Input, OnInit } from '@angular/core';
import { AppointmentCount } from 'src/app/core/interfaces/status-counts/appointment-counts';

@Component({
  selector: 'app-appointment-counts',
  templateUrl: './appointment-counts.component.html',
  styleUrls: ['./appointment-counts.component.scss'],
})
export class AppointmentCountsComponent implements OnInit {
  @Input() appointmentCounts: AppointmentCount;

  constructor() {}

  ngOnInit(): void {}
}
